import { render, staticRenderFns } from "./DocumentValidityQueryTimestamp.vue?vue&type=template&id=4dc9275d"
import script from "./DocumentValidityQueryTimestamp.vue?vue&type=script&lang=ts"
export * from "./DocumentValidityQueryTimestamp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports